import React, { useEffect } from 'react';
import { useSecureAuthContext } from '@/contexts/SecureAuthContext';
import { useImageQueue } from '@/hooks/useImageQueue';

// This component mounts globally to ensure the queue keeps processing
// regardless of the current page. It renders nothing.
const BackgroundQueueRunner: React.FC = () => {
  const { user } = useSecureAuthContext();

  // Mount the queue for the current user; effects inside the hook will handle processing
  const { queue, isProcessing } = useImageQueue(user?.id);

  return null;
};

export default BackgroundQueueRunner;
